export enum AccountType {
    Orders = "orders",
    User = "user",
    Reward = "reward",
    CompanyRequest = "companyrequest",
}

export function getAccountTypes(): AccountType[] {
    return [
        AccountType.Orders,
        AccountType.User,
        AccountType.Reward,
        AccountType.CompanyRequest,
    ];
}
